import {Component, Input, OnInit} from '@angular/core';
import {FilesService} from '../../services/files.service';
import {PdfToolsService} from '../../services/pdf-tools.service';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import {MatCheckboxModule} from '@angular/material/checkbox';

@Component({
    selector: 'fmc-file-selection',
    templateUrl: './file-selection.component.html',
    standalone: true,
    imports: [NgFor, MatCheckboxModule, FormsModule]
})
export class FileSelectionComponent implements OnInit {
  @Input() public idt: string;
  @Input() public idv: number;
  public selectedFiles: any;
  public checked = true;

  constructor(public filesService: FilesService,
              public pdfToolsService: PdfToolsService) {
  }

  ngOnInit() {
    this.pdfToolsService.getFileSelectionData().subscribe((data) => {
      this.selectedFiles = data;
    });
  }

  removeFile(file) {
    file.checked = false;
    this.pdfToolsService.removeFileSelectionData(file);
  }
}
